import { render, staticRenderFns } from "./UiFormContact.vue?vue&type=template&id=cfa522f4&scoped=true"
import script from "./UiFormContact.vue?vue&type=script&lang=js"
export * from "./UiFormContact.vue?vue&type=script&lang=js"
import style0 from "./UiFormContact.vue?vue&type=style&index=0&id=cfa522f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa522f4",
  null
  
)

export default component.exports